/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = WhatsAppDialog
 *
 * 1 = Lead
 *
 * 2 = Deal
 *
 * 3 = EnquiryCRM
 *
 * 4 = PayRequest
 *
 * 5 = Appraisal
 *
 * 6 = Appointment
 *
 * 7 = AppointmentPreparationLog
 *
 * 8 = Complaint
 *
 * 9 = VehicleRejection
 *
 * 10 = ServicePlanQuota
 *
 * 11 = Parts
 *
 * 12 = NewAppraisal
 *
 * 13 = ServiceBooking
 *
 * 14 = DeliveryDiary
 *
 * 15 = Handover
 *
 * 16 = ServiceProspecting
 *
 * 17 = SSSCalls
 *
 * 18 = WIP
 *
 * 19 = VIPPhoneCall
 *
 * 20 = WorkshopLog
 *
 * 21 = Reservation
 */
export enum ContactDialogReferenceType {
  WhatsAppDialog = 0,
  Lead = 1,
  Deal = 2,
  EnquiryCRM = 3,
  PayRequest = 4,
  Appraisal = 5,
  Appointment = 6,
  AppointmentPreparationLog = 7,
  Complaint = 8,
  VehicleRejection = 9,
  ServicePlanQuota = 10,
  Parts = 11,
  NewAppraisal = 12,
  ServiceBooking = 13,
  DeliveryDiary = 14,
  Handover = 15,
  ServiceProspecting = 16,
  SSSCalls = 17,
  WIP = 18,
  VIPPhoneCall = 19,
  WorkshopLog = 20,
  Reservation = 21,
}
